/* ----------------------------------
 - constants.js -
 JS全般で利用される定数
---------------------------------- */

// ログレベル定数
export const Level = {
  DEBUG: 10,
  INFO: 20,
  WARN: 30,
  ERROR: 40
}

// イベント定数
export const Event = {
  Login: 'vue-event-login',
  Logout: 'vue-event-logout',
  Messages: 'vue-event-messages'
}

export const ItemStatusKeys = {
  Editing: "Editing",
  Saved: "Saved",
  Declined: "Declined",
  WaitingApproval: "WaitingApproval",
  Approved: "Approved",
  Blocked: "Blocked"
}

export const UserRoleType = {
  Read: 'Read',
  Write: 'Write',
  Approve: 'Approve',
  ItemSpec: {
    Dep1ItemSpec: 'Dep1ItemSpec',
    Dep2ItemSpec: 'Dep2ItemSpec'
  },
  FactoryOrder: {
    Dep1SalesOrder: 'Dep1SalesOrder',
    Dep1Internal: 'Dep1Internal',
    Dep1Testing: 'Dep1Testing',
    Dep1FactoryOrder: 'Dep1FactoryOrder',
    Dep2SalesOrder: 'Dep2SalesOrder',
    Dep2Internal: 'Dep2Internal',
    Dep2Testing: 'Dep2Testing',
    Dep2FactoryOrder: 'Dep2FactoryOrder'
  },
  ProductionPlanning: {
    Dep1Planning: 'Dep1Planning',
    Dep1Create: 'Dep1Create',
    Dep1Adjust: 'Dep1Adjust',
    Dep1AdjustEg: 'Dep1AdjustEg',
    Dep2Planning: 'Dep2Planning',
    Dep2Create: 'Dep2Create',
    Dep2Adjust: 'Dep2Adjust',
    Dep2AdjustS: 'Dep2AdjustS'
  },
  ProductionAchievment: {
    CheckAchievment: 'CheckAchievment',
    AchivementTimeline: 'AchivementTimeline',
    LotSearch: 'LotSearch',
    ExportAchievment: 'ExportAchievment'
  },
  MaterialSpec: {
    MaterialSpecification: 'MaterialSpecification',
    MaterialOrderPlanCreate: 'MaterialOrderPlanCreate',
    MaterialOrderManagement: 'MaterialOrderManagement',
    ExportMaterialForecast: 'ExportMaterialForecast'
  },
  Finance: {
    FinanceExport: 'FinanceExport'
  },
  Trading: {
    ShipmentDocuments: 'ShipmentDocuments',
    DeliverySlip: 'DeliverySlip'
  },
  Admin: {
    User: 'User',
    Operator: 'Operator',
    Calendar: 'Calendar',
    ProductGroups: 'ProductGroups',
    Dep1Process: 'Dep1Process',
    Dep2Process: 'Dep2Process',
    System: 'System',
    Machine: 'Machine'
  }
}
export const PROCESS_NAME = {
  EG: "Eg",
  S: "S",
  SH: "SH"
}

export const Action = {}